module.exports = __webpack_public_path__ + "img/vezapodorysy6NP.138abc42.png";